import { FC } from 'react'
import { Check } from '../../assets'
import { SimulationButtonProps as Props } from './types'
import styles from './SimulationButton.module.scss'
import classNames from 'classnames'

const SimulationButton: FC<Props> = ({ title, onClick, highlighted, icon }) => (
  <div>
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
    <a
      href="#"
      className={classNames(styles['input-button'], { [styles.highlighted]: highlighted })}
      onClick={(e) => {
        e.preventDefault()
        onClick()
      }}
    >
      <div className={styles.inner}>
        <div className={styles.icon}>{icon}</div>
        <div className={styles.label}>{title}</div>
      </div>
      <div className={styles.check}>
        <Check viewBox="0 0 56 56" />
      </div>
    </a>
  </div>
)

export default SimulationButton
